import {useTranslation} from "react-i18next";
import {v4 as uuidv4} from "uuid";

export default function PopularSurveys({surveys}) {
    const { t } = useTranslation();
    return (
        <div className="popular-block">
            <h5>{t('surveys.popular')}</h5>
            <ol>
                {
                    surveys.map(survey =>
                        <li key={uuidv4()}>
                            <a href={"/surveys/" + survey.id}>{survey.title ?? survey.surveyTitle}</a>
                        </li>
                    )
                }
            </ol>
        </div>
    );
}
